module.exports = __webpack_public_path__ + "img/Alatfaithlogo.b00fa838.png";